<template>
    <div class="container">
        <div class="box-1"></div>
        <div class="box-2" v-if="signCouponShow">
            <img class="box-2-img" :src="drawList[signInCoupon.currentDate]">
            <div :class="['box-2-btn', signInCoupon.alreadyReceive && 'get']" @click="receiveSignCoupon('立领今日好礼')"></div>
        </div>
        <div class="box-3">
            <div class="box-3-wrap">
                <div class="coupon-item">
                    <img class="coupon-img" src="https://s21.lgstatic.com/growth/activity/20220331/1648709381072.png">
                    <img
                        v-if="!privateCourseCoupon.alreadyReceive"
                        class="coupon-receive"
                        src="https://s20.lgstatic.com/growth/activity/20220328/1648451198280.png"
                        @click="receivePrivateCourseCoupon('688-优惠券领取')"
                    >
                    <img v-else class="coupon-receive" src="https://s20.lgstatic.com/growth/activity/20220330/1648608500525.png">
                </div>
                <div class="coupon-item">
                    <img class="coupon-img" src="https://s20.lgstatic.com/growth/activity/20220331/1648709401265.png">
                    <img
                        v-if="!trainingCampCoupon.alreadyReceive"
                        class="coupon-receive"
                        src="https://s20.lgstatic.com/growth/activity/20220328/1648451198280.png"
                        @click="showTrainingCampCoupon('1288-优惠券领取')"
                    >
                    <img v-else class="coupon-receive" src="https://s20.lgstatic.com/growth/activity/20220330/1648608500525.png">
                </div>
            </div>
        </div>
        <div class="box-4">
            <img class="box-4-img" src="https://s21.lgstatic.com/growth/activity/20220328/1648451824202.png" @click="handleGoForm('96e584784cb94c178ea397db3e409117', '马上点击使用')">
        </div>
        <div class="box-5">
            <div class="box-5-wrap">
                <img @click="handleGoForm('a40eba32f41144c585fc4f5807c3fcd8', '21天-Java')" class="box-5-img" src="https://s21.lgstatic.com/growth/activity/20220331/1648709544127.png">
                <img @click="handleGoForm('85f92801944a4c1688e4747089b81f09', '21天-前端')" class="box-5-img" src="https://s21.lgstatic.com/growth/activity/20220331/1648709565839.png">
                <img @click="handleGoForm('1d83328706774282ba375526f7534144', '21天-测试')" class="box-5-img" src="https://s21.lgstatic.com/growth/activity/20220331/1648709576325.png">
            </div>
        </div>
        <div class="box-6">
            <div class="box-6-wrap">
                <img class="box-6-img" v-for="(train, i) in subjectList" :key="i" :src="train.imgUrl" @click="handleTrainClick(train, `1288-${train.subjectName}`)">
            </div>
        </div>
        <div class="box-7"></div>
        <div class="box-8" @click="handleGoForm('96e584784cb94c178ea397db3e409117', `大厂私教涨薪方案 限时领取`)"></div>
        <div v-if="receviceCouponModal" class="recevice-coupon">
            <div class="recevice-coupon-content">
                <div class="recevice-coupon-wrap">
                    <img class="recevice-coupon-img" src="https://s21.lgstatic.com/growth/activity/20220328/1648461576793.png">
                    <div class="subject-list">
                        <div
                            :class="{
                                'subject-item': true,
                                'actived': selectSubject == subject.type
                            }"
                            v-for="subject in subjectList"
                            :key="subject.type"
                            @click="handleSelectedSubject(subject.type)"
                        >{{subject.subjectName}}</div>
                    </div>
                </div>
                <div class="recevice-coupon-btn" @click="receiveTrainingCampCoupon">领取￥1288优惠券</div>
                <div class="close-btn" @click="receviceCouponModal = false"></div>
            </div>
        </div>
        <div v-if="receviceSuccessModal" class="recevice-success">
            <div class="recevice-content">
                <div class="recevice-wrap">
                    <img class="recevice-img" src="https://s20.lgstatic.com/growth/activity/20220328/1648454452724.png">
                    <div class="recevice-txt">优惠券已发送您 {{userLoginAccount}} 账户</div>
                </div>
                <div class="learn-btn" @click="goDetail">查看学科资料</div>
                <div class="later-btn" @click="receviceSuccessModal = false">稍后查看</div>
                <!-- <div class="close-btn" @click="receviceSuccessModal = false"></div> -->
            </div>
        </div>
        <div v-if="receviceSuccessModal2" class="recevice-success">
            <div class="recevice-content recevice-content-2">
                <div class="recevice-wrap">
                    <img class="recevice-img" src="https://s20.lgstatic.com/growth/activity/20220328/1648454452724.png">
                    <div class="recevice-txt">优惠券已发送您 {{userLoginAccount}} 账户</div>
                </div>
                <div class="close-btn-2" @click="receviceSuccessModal2 = false"></div>
            </div>
        </div>
        <div v-if="activityOver" class="recevice-success">
            <div class="recevice-content recevice-content-2">
                <div class="recevice-wrap">
                    <img class="recevice-img-1" src="https://s21.lgstatic.com/growth/activity/20220330/1648622119650.png">
                    <div class="recevice-txt">活动中领取的优惠券可至「我的 - 优惠券」中查看哦~</div>
                </div>
                <div class="recevice-coupon-btn" @click="activityOver = false">知道啦</div>
                <div class="close-btn-3" @click="activityOver = false"></div>
            </div>
        </div>
        <div v-if="showError" class="toast-error">{{errorMessage}}</div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { getBigCourseCoupon, getSignInCoupon, receiveBigCourseCoupon, receiveSignInCoupon, privateEducationV2, fetchUserInfo } from '../../../service/api'
import { handleJumpUrl } from '../../../uitl/getParam.js';
import share from '../../../common/js/share';
export default {
    data() {
        return {
            drawList: {
                413: 'https://s20.lgstatic.com/growth/activity/20220413/1649820110754.png',
                414: 'https://s21.lgstatic.com/growth/activity/20220413/1649820146847.png',
                415: 'https://s20.lgstatic.com/growth/activity/20220413/1649820168557.png',
                416: 'https://s20.lgstatic.com/growth/activity/20220413/1649820190581.png',
                417: 'https://s21.lgstatic.com/growth/activity/20220413/1649820213007.png',
                418: 'https://s21.lgstatic.com/growth/activity/20220413/1649820232045.png',
            },
            subjectList: [
                { type: 1, subjectName: "Java", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709857214.png',url: 'https://edu.lagou.com/growth/sem/java_architect.html', formId: 'd68a28c6a455442fbace617b3d27dc54' },
                { type: 2, subjectName: "前端", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709872346.png',url: 'https://edu.lagou.com/growth/sem/fe-next.html', formId: '60424ceaa6ca449983ec6b88cb4ab337' },
                { type: 3, subjectName: "大数据", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709884836.png',url: 'https://edu.lagou.com/growth/sem/data_enhancement.html', formId: 'b9bbe7ae829f4480bc0d860ebf2b1970' },
                { type: 4, subjectName: "数据分析", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709822126.png',url: 'https://edu.lagou.com/growth/sem/data_analysis.html', formId: 'ec5e7096784f4c12acb30509179da508' },
                { type: 5, subjectName: "测试", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709900045.png',url: 'https://edu.lagou.com/growth/sem/test_engineer.html', formId: '0279ee5641134bdd9c792ccdf89d319f' },
                { type: 6, subjectName: "产品", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709914157.png',url: 'https://edu.lagou.com/growth/sem/pm__enhancement.html', formId: 'f331871ccf91414896e61eacd84d1429' },
                { type: 7, subjectName: "运营", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'b81a5c0d7dc94c3f88de261065ea56b3' }
            ],
            privateCourseCoupon: {},
            trainingCampCoupon: {},
            userInfo: {},
            signInCoupon: {
                currentDate: 413
            },
            userLoginAccount: '',
            currentDraw: 13,
            selectSubject: '',
            receviceCurrent: false,
            receviceCouponModal: false,
            receviceSuccessModal: false,
            receviceSuccessModal2: false,
            showError: false,
            errorMessage: '',
            // 签到券是否过期 2022/04/16 00:00
            signCouponShow: new Date().getTime() < 1650297600000,
            // 活动是否过期 2022/04/26 00:00
            activityOver: new Date().getTime() > 1650902400000
        }
    },
    watch: {
        showError: function(newVal, oldVal) {
            if (newVal) {
                setTimeout(() => {
                    this.showError = false;
                }, 3000)
            }
        }
    },
    created () {
        this.saLogin();
        if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token')) {
          this.initCouponStatus();
        }
    },
    mounted () {
        this.eduPlatTrack('WebView', { page_id: 'b1tmk'});
        this.initShare();
    },
    methods: {
        initShare() {
            const shareMsg = {
                title: '喊你免费领礼品啦～',
                desc: '6天礼品狂送，快来点击领取>>>',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20220415/1649990517124.png'
            };
            share.init(shareMsg);
        },
        initCouponStatus() {
            getBigCourseCoupon().then(res => {
                if (res.state == 1) {
                    this.privateCourseCoupon = res.content.privateCourseCoupon || {};
                    this.trainingCampCoupon = res.content.trainingCampCoupon || {};
                }
            })
            getSignInCoupon().then(res => {
                if (res.state == 1) {
                    this.signInCoupon = res.content || {};
                    this.signCouponShow = res.content.valid;
                }
            })
            fetchUserInfo().then(res => {
                if (res.state == 1) {
                    this.userInfo = res.content || {};
                }
            })
        },
        receiveSignCoupon(buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            if (!this.signInCoupon.valid || this.signInCoupon.alreadyReceive) return;
            receiveSignInCoupon({
                couponNo: this.signInCoupon.couponNo
            }).then(res => {
                if (res.state == 1) {
                    this.userLoginAccount = res.content.userLoginAccount || '';
                    this.receviceSuccessModal2 = true;
                    this.initCouponStatus();
                } else {
                    this.errorMessage = res.message;
                    this.showError = true;
                }
            })
        },
        receivePrivateCourseCoupon(buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            if (this.isActivityOver()) {
                return this.activityOver = true;
            }
            this.selectSubject = '';
            const data = {
                couponNo: this.privateCourseCoupon.couponNo || '',
                subjectId: ''
            }
            this.receiveBigCourseCouponFn(data);
        },
        showTrainingCampCoupon(buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            this.selectSubject = '';
            this.receviceCouponModal = true;
        },
        receiveTrainingCampCoupon() {
            if (!this.selectSubject) {
                this.errorMessage = '请选择学科';
                this.showError = true;
                return;
            }
            const buttonName = `领取￥1288优惠券-${this.subjectList[this.selectSubject - 1].subjectName}`;
            this.eduPlatTrackFn(buttonName);
            const data = {
                couponNo: this.trainingCampCoupon.couponNo,
                subjectId: this.selectSubject
            }
            this.receiveBigCourseCouponFn(data);
        },
        receiveBigCourseCouponFn(data) {
            receiveBigCourseCoupon(data).then(res => {
                if (res.state == 1) {
                    this.userLoginAccount =  res.content.userLoginAccount || '';
                    this.receviceSuccessModal = true;
                    this.initCouponStatus();
                } else {
                    this.errorMessage = res.message;
                    this.showError = true;
                }
            }).finally(() => {
                this.receviceCouponModal = false;
            })
        },
        handleSelectedSubject(type) {
            this.selectSubject = type;
        },
        handleTrainClick(train, buttonName) {
            this.eduPlatTrackFn(buttonName);
            handleJumpUrl(train.formId);
        },
        goDetail() {
            this.eduPlatTrackFn('查看学科资料');
            if (!this.selectSubject) {
                window.location.href = 'https://edu.lagou.com/growth/sem/offer.html';
            } else {
                window.location.href = this.subjectList[this.selectSubject - 1].url;
            }
        },
        handleGoForm(key, buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (key == "96e584784cb94c178ea397db3e409117") { // 大厂私教
                if (!this.userInfo || !this.userInfo.hasPhone) {
                    handleJumpUrl(key);
                } else {
                    privateEducationV2({
                        formId: "146",
                        subjectId: "-999",
                        referName: window && window.location.href || ''
                    }).then(res => {
                        const { state } = res || {}
                        if (state == 1) {
                            handleJumpUrl(key)
                        }
                    })
                }
            } else {
                handleJumpUrl(key)
            }
        },
        isActivityOver() {
            return new Date().getTime() > 1650902400000
        },
        eduPlatTrackFn(buttonName) {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': 'b1tmk',
                'button_name': buttonName
            });
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    padding-bottom: 190px;
}
.box-1 {
    width: 100%;
    height: 872px;
    background: url("https://s20.lgstatic.com/growth/activity/20220330/1648621161104.png") no-repeat center;
    background-size: 100% 872px;
}
.box-2 {
    display: flex;
    width: 100%;
    height: 724px;
    background: url("https://s21.lgstatic.com/growth/activity/20220413/1649818064262.png") no-repeat center;
    background-size: 100% 724px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: -1px;
    .box-2-img {
        width: 596px;
        height: 232px;
        margin-top: 296px;
    }
    .box-2-btn {
        width: 100%;
        height: 85px;
        background: url("https://s20.lgstatic.com/growth/activity/20220329/1648540507874.png") no-repeat center;
        background-size: 370px 85px;
        margin-top: 36px;
        &.get {
            background: url("https://s21.lgstatic.com/growth/activity/20220329/1648540547878.png") no-repeat center;
            background-size: 370px 85px;
        }
    }
}
.box-3 {
    width: 100%;
    height: 647px;
    background: url("https://s21.lgstatic.com/growth/activity/20220331/1648709304408.png") no-repeat center;
    background-size: 100% 647px;
    overflow: hidden;
    margin-top: -1px;
    .box-3-wrap {
        display: flex;
        width: 652px;
        height: 397px;
        margin: 170px auto 0;
        padding: 30px;
        box-sizing: border-box;
        justify-content: space-between;
        .coupon-item {
            display: flex;
            width: 283px;
            height: 255px;
            padding: 21px 0 0 31px;
            box-sizing: border-box;
            flex-wrap: wrap;
        }
        .coupon-img {
            width: 232px;
            height: 187px;
        }
        .coupon-receive {
            width: 224px;
            height: 71px;
            margin-top: 0px;
        }
    }
}
.box-4 {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 813px;
    background: url("https://s20.lgstatic.com/growth/activity/20220328/1648448571295.png") no-repeat center;
    background-size: 100% 813px;
    margin-top: -1px;
    .box-4-img {
        width: 499px;
        height: 130px;
        margin-top: 650px;
        margin-left: 42px;
    }
}
.box-5 {
    width: 100%;
    height: 838px;
    background: url("https://s21.lgstatic.com/growth/activity/20220331/1648709464218.png") no-repeat center;
    background-size: 100% 838px;
    overflow: hidden;
    margin-top: -1px;
    .box-5-wrap {
        display: flex;
        width: 653px;
        height: 271px;
        margin: 534px auto 0;
        padding: 17px 17px 0 20px;
        box-sizing: border-box;
        justify-content: space-between;
        .box-5-img {
            width: 192px;
            height: 219px;
        }
    }
}
.box-6 {
    width: 100%;
    height: 1104px;
    background: url("https://s20.lgstatic.com/growth/activity/20220331/1648712468024.png") no-repeat center;
    background-size: 100% 1104px;
    overflow: hidden;
    margin-top: -1px;
    .box-6-wrap {
        display: flex;
        width: 653px;
        height: 887px;
        margin: 176px auto 0;
        padding: 20px 18px 0;
        box-sizing: border-box;
        justify-content: space-between;
        flex-wrap: wrap;
        .box-6-img {
            width: 303px;
            height: 200px;
        }
    }
}
.box-7 {
    width: 100%;
    height: 500px;
    background: url("https://s20.lgstatic.com/growth/activity/20220413/1649819927978.png") no-repeat center;
    background-size: 100% 500px;
    margin-top: -1px;
}
.box-8 {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 190px;
    background: url("https://s21.lgstatic.com/growth/activity/20220328/1648448637777.png") no-repeat center;
    background-size: 100% 190px;
}
.recevice-success {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
        &-2 {
            height: 286px;
        }
    }
    .recevice-wrap {
        width: 600px;
        height: 286px;
        background-color: #554EDD;
        border-radius: 12px;
        overflow: hidden;
        padding: 0 30px;
        box-sizing: border-box;
        .recevice-img {
            display: block;
            width: 202px;
            height: 40px;
            margin: 92px auto 0;
            &-1 {
                display: block;
                width: 250px;
                height: 40px;
                margin: 75px auto 0;
            }
        }
        .recevice-txt {
            text-align: center;
            font-size: 26px;
            color: #fff;
            margin-top: 31px;
        }
    }
    .recevice-coupon-btn {
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(166deg, #F5F5FF, #CFD6FF);
        font-size: 36px;
        font-weight: bold;
        color: #5451D5;
        margin: 30px auto 0;
    }
    .learn-btn {
        width: 389px;
        height: 80px;
        background: linear-gradient(166deg, #F5F5FF, #CFD6FF);
        border-radius: 40px;
        margin: 39px auto 0;
        line-height: 80px;
        text-align: center;
        font-size: 36px;
        color: #5451D5;
        font-weight: bold;
    }
    .later-btn {
        margin-top: 32px;
        text-align: center;
        font-size: 30px;
        font-style: italic;
        color: #fff;
    }
    .close-btn {
        position: absolute;
        bottom: -70px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-2 {
        position: absolute;
        bottom: -110px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-3 {
        position: absolute;
        top: -106px;
        right: 0;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 600px;
        height: 555px;
        background-color: #554EDD;
        border-radius: 12px;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 324px;
            height: 87px;
            margin: 92px auto 0;
        }
        .subject-list {
            display: flex;
            width: 557px;
            height: 212px;
            padding-top: 42px;
            margin: 47px auto 0;
            box-sizing: border-box;
            background-color: #4C49CA;
            border-radius: 4px;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 113px;
                height: 54px;
                line-height: 54px;
                padding: 0 14px;
                box-sizing: border-box;
                font-size: 26px;
                color: #fff;
                text-align: center;
                margin-bottom: 27px;
                margin-right: 20px;
                background-color: #8583F5;
                border-radius: 3px;
                &:nth-child(4) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #3931A3;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(166deg, #F5F5FF, #CFD6FF);
        font-size: 36px;
        font-weight: bold;
        color: #5451D5;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -140px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
}
.toast-error {
    position: fixed;
    top: 30%;
    left: 50%;
    padding: 8px 16px;
    background-color: rgba(0, 0, 0, .6);
    color: #fff;
    transform: translateX(-50%);
    z-index: 999;
    font-size: 30px;
    border-radius: 4px;
}
</style>
